var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loading-wrapper" }, [
    _vm.loadingType === "ring"
      ? _c("div", { staticClass: "loading-ring" }, [_c("div")])
      : _vm._e(),
    _vm._v(" "),
    _vm.loadingType === "dot"
      ? _c("div", { staticClass: "dot" }, [
          _c("div", { staticClass: "bounce1" }),
          _vm._v(" "),
          _c("div", { staticClass: "bounce2" }),
          _vm._v(" "),
          _c("div", { staticClass: "bounce3" })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }